import { uploadOrKeepImg } from '../../common'
import { parseImage } from '../utils'
import { DrinkVariantToApi } from './types/api/request-models'
import { APIDrinkVariant } from './types/api/response-models'
import { DrinkVariant } from './types/internal/drink-models'

// ============
// PARSE
// ============

export const drinkVariantParse = ({
  image,
  ...rest
}: APIDrinkVariant): DrinkVariant => ({
  image: parseImage(image),
  ...rest,
})

// ============
// WRITE
// ============

export const drinkVariantWrite = async ({
  image,
  ...rest
}: DrinkVariant): Promise<DrinkVariantToApi> => ({
  ...rest,
  image: await uploadOrKeepImg(image),
})
